import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SimpleInput',
  props: {
  type: {
    type: String,
    default: 'text',
  },
},
  setup(__props, { expose }) {
  expose();

const props = __props



const p = 'password'
const t = 'text'

const inputType = ref(props.type)

/* eslint-disable */
const isPasswordField = inputType.value === p

const toggleType = () => inputType.value = inputType.value === p ? t : p



const __returned__ = { props, p, t, inputType, isPasswordField, toggleType, ref }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})